// @flow

import { STUDIO_STEP_ROUTES } from 'src/modules/gandi-studio';

export type Step = 'accountChoice' | 'overview' | 'firstBuy' | 'account';

type Params = {
  isStudioUser: boolean,
  flag: boolean,
  hasPhone: boolean,
  hasAddress: boolean,
  hasOtherProducts: boolean,
};

// Complete profile: account choice if the flag is on or the cart holds
// non-studio products, otherwise straight to the overview.
// Incomplete profile: studio users get the phone page only when the flag
// is off and just the phone is missing; everything else goes to first buy.
export function getStepAfterDomainChoice({
  isStudioUser,
  flag,
  hasPhone,
  hasAddress,
  hasOtherProducts,
}: Params): Step {
  if (hasPhone && hasAddress) {
    return flag || hasOtherProducts ? 'accountChoice' : 'overview';
  }

  if (isStudioUser) {
    if (flag) return 'firstBuy';
    return hasAddress ? 'account' : 'firstBuy';
  }

  return 'firstBuy';
}

export const getStepUrl = (cartId: string): Record<Step, string> => ({
  accountChoice: STUDIO_STEP_ROUTES.accountChoice.replace(':cartId', cartId),
  overview: STUDIO_STEP_ROUTES.overview.replace(':cartId', cartId),
  firstBuy: STUDIO_STEP_ROUTES.firstBuy.replace(':cartId', cartId),
  account: STUDIO_STEP_ROUTES.account.replace(':cartId', cartId),
});
